export default function block_announcements() {
	const announcementsContainer = $('#live-announcements')
	const lastUpdated = $('#last-updated')
	const announcementsSource = 'https://s3.amazonaws.com/assets.liveracemedia.com/event_files/7478/announcements.json'
	const testAnnouncementesSource = [
		{
			microsecondsUTC: 1694524800000000,
			dateTimeLocalDisplay: "2025-01-10T12:00:00",
			message: "Race started."
		},
		{
			microsecondsUTC: 1694524860000000,
			dateTimeLocalDisplay: "2025-01-10T12:01:00",
			message: "First checkpoint reached."
		},
		{
			microsecondsUTC: 1694524920000000,
			dateTimeLocalDisplay: "2025-01-10T12:02:00",
			message: "Second checkpoint reached."
		},
		{
			microsecondsUTC: 1694525100000000,
			dateTimeLocalDisplay: "2025-01-10T12:05:00",
			message: "Race completed."
		}
	]

	function renderAnnouncements(data) {
		announcementsContainer.empty();

		data.forEach(function(announcement) {
			var time = new Date(announcement.microsecondsUTC / 1000).toLocaleTimeString();
			
			var $listItem = $('<div>')
				.addClass('announcement')
				.html(
					'<span class="announcement-time">' + announcement.dateTimeLocalDisplay + '</span> ' +
					'<h3 class="announcement-message">' + announcement.message + '</h3>'
				);
			announcementsContainer.append($listItem);
		});
		
		lastUpdated.text(new Date().toLocaleTimeString());   
		$('.live-blog-block').removeClass('announcements-loading')
	}

	function announcementsApiCall() {
		$.ajax({
			url: announcementsSource,
			method: 'GET',
			dataType: 'json',
			success: function(data) {				
				if(data.length === 0) {
					console.error('Announcements empty')
				} else{
					$('#live-blog-block').addClass('active')
					renderAnnouncements(data);
				}
			},
			error: function(xhr, status, error) {
				console.error('Error fetching announcements:', error)
			}
		});
	}

	function displayAnnouncements(mode) {

		if(mode === 'test') {
			$('.live-blog-block').addClass('active')
			setTimeout(function() {
				$('.live-blog-block').removeClass('announcements-loading')
				renderAnnouncements(testAnnouncementesSource)
			}, 1000)
		} else {
			announcementsApiCall()
		}
		
	}

	setInterval(displayAnnouncements(), 60000)

}